module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataReady) ? _c('header', {
    staticClass: "tw-select-none tw-flex tw-h-20 tw-w-full tw-bg-sky-700 tw-text-white tw-bg-header-texture"
  }, [_c('div', {
    staticClass: "tw-flex tw-grow tw-flex-col tw-h-20 tw-border-r tw-border-sky-900"
  }, [_c('div', {
    staticClass: "tw-flex tw-h-10"
  }, [_vm._m(0), _vm._v(" "), (!_vm.estModeBloque()) ? _c('div', {
    staticClass: "tw-flex tw-items-center",
    attrs: {
      "data-testid": "header-payPeriod-section"
    }
  }, [_c('div', {
    staticClass: "tw-mr-3",
    attrs: {
      "title": 'Période active - ' + _vm.getDatePeriodeActive()
    }
  }, [_c('span', {
    staticClass: "fa-solid fa-calendar-alt tw-mr-1 tw-text-teal-400"
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-mr-2"
  }, [_vm._v("Période active :")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getDatePeriodeActive()) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "tw-mr-3"
  }, [_c('span', {
    staticClass: "fa-solid fa-edit tw-mr-1 tw-text-teal-400"
  }), _vm._v(" "), (_vm.getEtatSaisieLibelle() !== undefined) ? _c('span', [_vm._v(_vm._s(_vm.getEtatSaisieLibelle()))]) : _c('span', [_vm._v("Non défini")])]), _vm._v(" "), (_vm.setDisplayButton()) ? _c('div', {
    staticClass: "tw-mr-2",
    attrs: {
      "title": "Soumettre"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "fas fa-check fa-fw",
      "data-testid": "header-payPeriod-validerElements-button",
      "color": "teal",
      "title": "Valider les éléments variables du mois",
      "text": "Valider les éléments variables du mois"
    },
    on: {
      "click": function($event) {
        _vm.onSoumettre()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.setDisplayButtonValider()) ? _c('div', {
    staticClass: "tw-mr-2",
    attrs: {
      "title": "Valider"
    }
  }, [_c('Button', {
    attrs: {
      "icon": "fas fa-check fa-fw",
      "data-testid": "header-payPeriod-validerSaisie-button",
      "color": "teal",
      "title": "Valider la saisie",
      "text": "Valider la saisie",
      "disabled": _vm.isValiderSaisieDisabled
    },
    on: {
      "click": function($event) {
        _vm.valider()
      }
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.estModeBloque()) ? _c('div', {
    ref: "tabItems",
    staticClass: "tw-flex tw-h-10"
  }, [(_vm.isMenuAllowed) ? _c('div', {
    staticClass: "tw-w-12 tw-h-10 tw-items-center tw-justify-center tw-flex tw-cursor-pointer z-1000 tw-duration-200 ",
    class: !_vm.activeMenu ? 'hover:tw-bg-blue-inot-hover' : 'tw-bg-blue-inot tw-bg-sky-700 hover:tw-bg-blue-inot-hover',
    attrs: {
      "data-testid": "header-mainMenu-button",
      "data-cy": "cy-menu-button-toggle"
    },
    on: {
      "click": function($event) {
        _vm.toggleStateModeMenu()
      }
    }
  }, [_c('span', {
    staticClass: "fa-solid fa-fw fa-lg",
    class: !_vm.activeMenu ? 'fa-bars' : 'fa-xmark tw-text-red-400 tw-duration-200'
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "tw-flex"
  }, _vm._l((_vm.tabItems), function(item) {
    return (_vm.tabItems.length > 1 || _vm.isMenuAllowed && item.id === 0) ? _c('li', {
      staticClass: "tw-items-center tw-justify-center tw-flex tw-px-3 tw-duration-200",
      class: [item.active ? 'tw-bg-white tw-text-red-400' : 'tw-bg-sky-700 tw-text-gray-300 tw-cursor-pointer',
        _vm.tabItems.length === 1 ? 'tw-rounded-t' : 'first:tw-rounded-tl last:tw-rounded-tr tw-border-r tw-border-blue-inot last:tw-border-r-0'
      ],
      style: (_vm.getTabWidth(item)),
      attrs: {
        "data-testid": "header-tab",
        "title": item.titre
      },
      on: {
        "click": function($event) {
          _vm.navigateTo(item.route)
        }
      }
    }, [(item.id > 0) ? _c('span', {
      staticClass: "tw-grow tw-font-bold tw-uppercase tw-whitespace-nowrap tw-text-ellipsis tw-overflow-hidden",
      attrs: {
        "data-testid": "header-tab-text"
      }
    }, [_vm._v(_vm._s(item.titre))]) : _c('span', {
      staticClass: "fa-duotone fa-house-chimney fa-fw fa-lg",
      attrs: {
        "data-testid": "header-tab-home"
      }
    }), _vm._v(" "), (_vm.isMenuAllowed && item.id > 0) ? _c('div', {
      staticClass: "tw-cursor-pointer tw-ml-3 tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center tw-duration-200 tw-rounded-full tw-min-w-6",
      class: item.active ? 'tw-bg-gray-100 hover:tw-bg-gray-200' : 'tw-bg-sky-800 hover:tw-bg-sky-900',
      attrs: {
        "data-testid": "header-tab-close-button",
        "title": "Fermer l'onglet"
      },
      on: {
        "click": function($event) {
          _vm.closeTab(item.route)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-times"
    })]) : _vm._e()]) : _vm._e()
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-h-20"
  }, [(_vm.enableAppPanel) ? _c('div', {
    staticClass: "tw-flex tw-px-4 tw-border-r tw-border-sky-900 tw-h-full tw-items-center tw-relative tw-cursor-pointer tw-group",
    attrs: {
      "title": "Afficher l'accès rapide"
    },
    on: {
      "click": function($event) {
        _vm.togglePanelHeaderApp()
      }
    }
  }, [_c('div', {
    staticClass: "tw-relative"
  }, [_c('span', {
    staticClass: "fa-sharp fa-solid fa-grid fa-xl fa-fw tw-duration-200",
    class: _vm.viewPanelApp ? 'tw-text-sky-500' : 'tw-text-white group-hover:tw-text-gray-300'
  }), _vm._v(" "), _c('panel-popup', {
    attrs: {
      "isVisible": _vm.viewPanelApp,
      "width": "190",
      "x": "12",
      "y": "15"
    }
  }, [_c('div', {
    staticClass: "tw-font-semibold tw-text-center tw-pt-2 tw-px-3"
  }, [_vm._v("Accès rapide")]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-items-center tw-flex-col tw-gap-1 tw-p-2"
  }, [_c('div', {
    staticClass: "hover:tw-bg-gray-200 tw-bg-gray-100 tw-border tw-border-gray-200 tw-cursor-pointer tw-duration-200 tw-rounded tw-p-2 tw-w-full tw-flex tw-flex-col tw-items-center",
    attrs: {
      "title": "Foederis"
    },
    on: {
      "click": _vm.openFoederisNewTab
    }
  }, [_c('img', {
    staticClass: "tw-w-4/5",
    attrs: {
      "src": require("../../assets/1-FOEDERIS-logo-fr-horiz-RVB.svg"),
      "alt": "foederis"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-text-xs tw-mt-2"
  }, [_vm._v("Foederis solution RH")])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isPst) ? _c('div', {
    staticClass: "tw-min-w-fit tw-flex tw-border-r tw-border-sky-900 tw-h-full tw-items-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/status-pill.svg"),
      "alt": "Status fill"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.estModeBloque()) ? _c('div', {
    staticClass: "tw-flex tw-px-4 tw-border-r tw-border-sky-900 tw-h-full tw-items-center",
    attrs: {
      "data-testid": "header-etude-section",
      "title": _vm.header.Societes[0].Libelle
    }
  }, [_c('span', {
    staticClass: "tw-mr-2",
    attrs: {
      "data-testid": "header-etude-text"
    }
  }, [_vm._v("Étude :")]), _vm._v(" "), (_vm.isSingleSociete) ? _c('div', {
    staticClass: "tw-font-bold tw-text-xs tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-max-w-xs",
    attrs: {
      "data-testid": "header-etude-name"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.societeActive.Libelle) + "\n\t\t\t\t")]) : _c('input-select', {
    staticClass: "tw-w-72",
    attrs: {
      "label": "Motif du recours",
      "code": "Code",
      "display": "Libelle",
      "textSmall": true,
      "textBold": true,
      "textUppercase": true,
      "textLowerCaseButFirst": true,
      "overflowList": true,
      "truncMiddle": true,
      "ellipsis": false,
      "mini": true,
      "first": false,
      "list": _vm.header.Societes,
      "vmodel": _vm.codeSocieteActive
    },
    on: {
      "update:vmodel": function($event) {
        _vm.codeSocieteActive = $event
      },
      "change": function($event) {
        _vm.onSocieteActiveChanged()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activePanelNotif && !_vm.estModeBloque()) ? _c('div', {
    staticClass: "tw-flex tw-px-4 tw-border-r tw-border-sky-900 tw-h-full tw-items-center tw-relative tw-cursor-pointer tw-group",
    attrs: {
      "data-testid": "header-notification-button",
      "title": "Afficher les notifications"
    },
    on: {
      "click": function($event) {
        _vm.togglePanelHeaderNotif()
      }
    }
  }, [_c('div', {
    staticClass: "tw-relative"
  }, [_c('span', {
    staticClass: "fa-solid fa-bell fa-xl fa-fw tw-duration-200",
    class: _vm.viewPanelNotif ? 'tw-text-yellow-400' : 'tw-text-white group-hover:tw-text-yellow-200'
  }), _vm._v(" "), (_vm.haveNewNotification) ? _c('span', {
    staticClass: "tw-rounded-full tw-absolute tw-text-xs tw--right-1 tw--top-3 tw-p-1 tw-leading-3 tw-text-white tw-animate-bounce tw-bg-red-400 tw-font-semibold"
  }, [_vm._v("!")]) : _vm._e(), _vm._v(" "), _c('notification-panel', {
    attrs: {
      "isVisible": _vm.viewPanelNotif,
      "viewPanelNotif": _vm.viewPanelNotif,
      "x": "12",
      "y": "15"
    },
    on: {
      "updateNewNotif": _vm.updateNewNotif
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-px-4 tw-h-full tw-items-center tw-relative tw-cursor-pointer tw-group",
    attrs: {
      "title": _vm.getIntituleUtilisateur(),
      "data-testid": "header-userMenu-button"
    },
    on: {
      "click": function($event) {
        _vm.togglePanelHeaderProfil()
      }
    }
  }, [_c('div', {
    staticClass: "jimo-widget tw-pointer-events-none tw-pb-8 tw-pl-4 tw-absolute tw-z-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-relative"
  }, [_c('div', {
    staticClass: "fa-solid fa-circle-user fa-xl fa-fw tw-duration-200",
    class: _vm.viewPanelProfil ? 'tw-text-sky-500' : 'tw-text-white group-hover:tw-text-sky-200'
  }), _vm._v(" "), _c('panel-popup', {
    staticClass: "tw-w-48",
    attrs: {
      "isVisible": _vm.viewPanelProfil,
      "data-testid": "header-userMenu-popup",
      "maxWidth": "190",
      "x": "12",
      "y": "15"
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-py-2 tw-px-3",
    attrs: {
      "title": _vm.getIntituleUtilisateur()
    }
  }, [_c('span', {
    staticClass: "tw-flex tw-border tw-w-7 tw-h-7 tw-mr-2 tw-rounded-full tw-border-gray-300 tw-min-w-7 tw-bg-gray-100"
  }, [_c('span', {
    staticClass: "tw-text-sm\ttw-flex tw-items-center tw-justify-center tw-w-full"
  }, [_vm._v(_vm._s(_vm.getInitial()))])]), _vm._v(" "), _c('span', {
    staticClass: "tw-font-semibold tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap",
    attrs: {
      "data-testid": "header-userMenu-userName"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getIntituleUtilisateur()) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-vertical",
    class: [{
        'tw-invisible': !_vm.viewPanelProfil
      },
      {
        'tw-visible': _vm.viewPanelProfil
      }
    ]
  }, [_c('li', {
    staticClass: "tw-flex tw-items-center tw-py-2 tw-px-3 hover:tw-bg-gray-200 tw-cursor-pointer tw-duration-200",
    attrs: {
      "data-testid": "header-userMenu-aideEnLigne"
    },
    on: {
      "click": function($event) {
        _vm.openLink()
      }
    }
  }, [_c('span', {
    staticClass: "tw-grow"
  }, [_vm._v("Aide en ligne")]), _vm._v(" "), _c('span', {
    staticClass: "fa-solid fa-angle-right tw-text-gray-500"
  })]), _vm._v(" "), (_vm.dataReady && _vm.societeActive !== undefined && _vm.isPst) ? _c('div', {
    staticClass: "tw-border-b tw-border-gray-300"
  }) : _vm._e(), _vm._v(" "), (_vm.dataReady && _vm.societeActive !== undefined && _vm.isPst) ? _c('li', {
    staticClass: "tw-flex tw-items-center tw-py-2 tw-px-3 hover:tw-bg-gray-200 tw-cursor-pointer tw-duration-200",
    on: {
      "click": function($event) {
        _vm.sendMail()
      }
    }
  }, [_c('span', {
    staticClass: "tw-grow"
  }, [_vm._v("Contacter la PST")]), _vm._v(" "), _c('span', {
    staticClass: "fa-regular fa-envelope tw-text-gray-500"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tw-border-b tw-border-gray-300"
  }), _vm._v(" "), _c('li', {
    staticClass: "tw-flex tw-items-center tw-py-2 tw-px-3 hover:tw-bg-gray-200 tw-cursor-pointer tw-duration-200",
    attrs: {
      "data-testid": "header-userMenu-JIMO-Changelog"
    }
  }, [_c('div', {
    staticClass: "jimo-widget tw-grow"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tNotes de version\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "fa-solid fa-angle-right tw-text-gray-500"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-border-b tw-border-gray-300"
  }), _vm._v(" "), _c('li', {
    staticClass: "tw-flex tw-items-center tw-py-2 tw-px-3 hover:tw-bg-gray-200 tw-cursor-pointer tw-duration-200",
    attrs: {
      "data-testid": "header-userMenu-deconnexion"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('span', {
    staticClass: "tw-grow"
  }, [_vm._v("Déconnexion")]), _vm._v(" "), _c('span', {
    staticClass: "fa-solid fa-right-from-bracket tw-text-red-500"
  })])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tw-absolute tw-h-full tw-w-full z-1000",
    class: _vm.viewPanelApp || _vm.viewPanelNotif || _vm.viewPanelProfil || _vm.activeBentoMenu ? 'tw-block' : 'tw-hidden',
    on: {
      "click": function($event) {
        _vm.closePanelHeader()
      }
    }
  })]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-flex tw-items-center tw-mr-3"
  }, [_c('img', {
    staticClass: "tw-h-full",
    attrs: {
      "src": require("../../assets/logo_v2/talent-blanc-couleur.svg"),
      "alt": "Logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76f5f338"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/context/context.vue.html
// module id = IGfA
// module chunks = 2